import React from "react";
import "./Paper.css";
import bucketpaper from "./image/BucketElevatorChain.jpg";
import coal from "./image/Coal-feeder-chain.jpg";
import drag from "./image/Drag-chain.jpg";
import nmass from "./image/nmass-conveyor-chain.jpg";

const Paper = () => {
  return (
    <div>
      <div className="paperp">
        <p className="p">Paper Industry</p>
        <div className="p2">
          {/* <p>Swajit Engineering Pvt.Ltd: &gt; Products &gt; Paper Industry</p> */}
        </div>
      </div>

      <div className="paperr">
        <div className="pimg">
          <figure>
            <img src={bucketpaper} alt="Ash Chain" />
            <figcaption>Bucket Elevator Chain</figcaption>
          </figure>
        </div>

        <div className="pimg">
          <figure>
            <img src={coal} alt="Drag Chain" />
            <figcaption>Coal Feeder Chain</figcaption>
          </figure>
        </div>

        <div className="pimg">
          <figure>
            <img src={drag} alt="Gate Chain" />
            <figcaption>Drag Chain</figcaption>
          </figure>
        </div>

        <div className="pimg">
          <figure>
            <img src={nmass} alt="Travelling Chain" />
            <figcaption>Nmass Conveyor Chain(Redler)</figcaption>
          </figure>
        </div>
      </div>
    </div>
  );
};

export default Paper;
